import {Number3} from '../../../../../../types/GlobalTypes';
export class TriangleNode {
	constructor(public readonly id: number, public readonly triangle: Number3) {}
}
